import AgendaRepository from './agenda'
export default {
    AgendaRepository
}